import Button from "@/components/ui/button";

export default function VVVPrimaryButton({
  name,
  className,
  action,
  disable,
  type = "button",
}) {
  return (
    <Button
      className={`rounded-full bg-primary text-white hover:bg-primaryLight hover:shadow-[0px_4px_20px_rgba(52,61,246,0.25)] transition-shadow duration-300 py-[22px] flex items-center ${className}`}
      type={type}
      onClick={action}
      disabled={disable}
    >
      {name}
    </Button>
  );
}
